import React from 'react'
import { close_icon } from '../../assets/images'
import { RadioGroup } from '../common/atoms'
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles'

const CreateOrUpdateTeamModel = ({ visible, icon, text = 'create', radioList=[], subTitle=[], btnText = 'Continue', onCancel, radioBtnValue, radioName, data, formHandler = () => {}, handler = () => {},  ...props }) => {

  return (
    <div
    className={`fixed z-20 inset-0  overflow-y-auto ${visible ? '' : 'hidden'}`}
    aria-labelledby='modal-title'  
    aria-modal='true'
  >
    <div className='flex items-end justify-center pt-4 px-4  text-center sm:block '>
      <div
        className='fixed inset-0 bg-gray-900 bg-opacity-25 transition-opacity'
        aria-hidden='true'
        onClick={onCancel}
      > </div>

      <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
        &#8203;
      </span>

      <div 
        className='inline-block align-bottom bg-white rounded-lg text-left transform duration-75 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full'
       style ={{width : '720px'}}
      >

        <div className='flex flex-row-reverse pt-4 pr-4 '>
        <img src={close_icon} alt='closeIcon' className='cursor-pointer' onClick={onCancel} />
        </div>
        <div className='px-8'>
        <h3 className='text-xl leading-6 font-extrabold text-gray-700 mb-8' id='modal-title'>
           Are you sure you want to {text} stepathon ?
        </h3> 
        <div className='w-full'>
          <RadioGroup
            name={radioName}
            width='550px'
            radioList={radioList}
            radio
            subLabel = {[<span className='text-white inline-block text-xs rounded-full px-2 py-1 ml-2 tracking-wider font-semibold bg-green-700' style={{fontSize: '10px', letterSpacing: '1px'}}>RECOMMENDED</span>, '']}
            subTitle = {subTitle}
            radioInputClasses='h-5 w-5 focus:ring-0 focus:ring-white'
            labelClases='text-gray-700 text-base leading-4 ml-3 font-semibold font-proxima-nova'
            radioClasses='inline-grid'
            subTitleClasses='text-gray-600 ml-8 mt-1.5 mb-6 text-xs font-proxima-nova'
            value={radioBtnValue}
            handler={(e) => formHandler(e)}
          />
        </div>
        </div>
        
        <div className="bg-gray-100 px-8 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button type="button" className={joinButtonClasses(dsButtonPrimary, 'w-full h-11 px-6 sm:ml-3 sm:w-auto sm:text-sm')} onClick={(e) => handler(e.target, data)}>{btnText}</button>
          <button type="button" className={joinButtonClasses(dsButtonSecondary, 'mt-3 w-full h-11 px-6 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm')}  onClick={onCancel}>Cancel</button>
        </div>
      </div>
    
    </div>
  </div>
   )
}

export default CreateOrUpdateTeamModel
